import { render } from "./Forbidden.vue?vue&type=template&id=9459eeb6&scoped=true"
const script = {}

import "./Forbidden.vue?vue&type=style&index=0&id=9459eeb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9459eeb6"]])

export default __exports__